export const generateDroppableLocationIdWithSection = (
  sectionLayoutType,
  sectionNumber
) => `${sectionLayoutType}-${sectionNumber}`;
